// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

import consumer from "./consumer"

// Expose consumer globally for use in non-webpack pages (like public queue tracking)
window.App = window.App || {};
window.App.cable = consumer;

const channels = require.context('.', true, /_channel\.js$/)
channels.keys().forEach(channels)
